import { render, staticRenderFns } from "./pNumeric.vue?vue&type=template&id=8e1f4740&"
import script from "./pNumeric.vue?vue&type=script&async=true&lang=js&"
export * from "./pNumeric.vue?vue&type=script&async=true&lang=js&"
import style0 from "./pNumeric.vue?vue&type=style&index=0&id=8e1f4740&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports